import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext, forwardRef } from "react";
import { GlobalContext, ContentContext } from "../../../context";


export default function Series() {
  const { 
    theme, setTheme, 
    activeHref, setActiveHref,
    density, setDensity 
  } = useContext(GlobalContext);
  const { 
    activeSeries, setActiveSeries
  } = useContext(ContentContext);
  const [activeTabId, setActiveTabId] = useState("series");
  
  return (
    <>
      <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
        <img
          src="/images/s5000/s5000-1.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
        <img
          src="/images/s5000/s5000-2.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
        <img
          src="/images/s5000/s5000-3.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
        <img
          src="/images/s5000/s5000-4.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
        <img
          src="/images/s5000/s5000-6.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
        <img
          src="/images/s5000/s5000-7.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
        <img
          src="/images/s5000/s5000-8.jpg"
          alt="S5000 Series"
          width={"100%"}
        />
      </div>
    </>
  );
}
